export default function Skeleton({ className = '', variant = 'rectangular' }) {
  const baseClasses = 'animate-pulse bg-gradient-to-r from-[#f5f5f7] to-[#e8e8ed] dark:from-[#2c2c2e] dark:to-[#1c1c1e]';

  const variantClasses = {
    rectangular: 'rounded-2xl',
    circular: 'rounded-full',
    text: 'rounded-lg h-4'
  };

  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${className}`} />
  );
}

export function CardSkeleton() {
  return (
    <div className="bg-gradient-to-br from-[#f5f5f7] to-[#e8e8ed] dark:from-[#2c2c2e] dark:to-[#1c1c1e] rounded-3xl p-6 sm:p-8 animate-pulse">
      <Skeleton variant="circular" className="w-12 h-12 sm:w-14 sm:h-14 mb-4 sm:mb-6" />
      <Skeleton variant="text" className="w-3/4 mb-2 sm:mb-3 h-6 sm:h-8" />
      <Skeleton variant="text" className="w-full mb-2" />
      <Skeleton variant="text" className="w-5/6 mb-4 sm:mb-6" />
      <Skeleton variant="rectangular" className="w-32 h-10 sm:h-12" />
    </div>
  );
}

export function HistorySkeleton() {
  return (
    <div className="bg-[#f5f5f7] dark:bg-[#2c2c2e] rounded-2xl p-4 animate-pulse">
      <div className="flex items-center gap-4">
        <Skeleton variant="rectangular" className="w-12 h-12 rounded-xl" />
        <div className="flex-1">
          <Skeleton variant="text" className="w-2/3 mb-2 h-5" />
          <Skeleton variant="text" className="w-1/2 h-4" />
        </div>
        <Skeleton variant="circular" className="w-5 h-5" />
      </div>
    </div>
  );
}
